import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  makeStyles,
  Divider,
  IconButton,
  List,
  useTheme
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { StyledDrawer, DrawerHeader } from './StyledComponents';
import DrawerListItem from './DrawerListItem';
import { navigationRoutes } from '../../../routes/routes';

const useStyles = makeStyles({
  groupBadge: {
    '& .MuiBadge-badge': {
      background: '#3498DB',
      color: 'white'
    }
  }
}, { name: 'NavigationDrawer' });

const NavigationDrawer = ({
  drawerOpen,
  handleDrawerClose,
  handleDrawerOpen ,
  badgeInfo = {}
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <StyledDrawer
        variant="permanent" open={ drawerOpen } theme={ theme }
      >
        <DrawerHeader theme={ theme }>
          <IconButton onClick={ drawerOpen ? handleDrawerClose : handleDrawerOpen }>
            { drawerOpen ? <ChevronLeftIcon /> : <ChevronRightIcon /> }
          </IconButton>
        </DrawerHeader>
        <Divider/>
        <List>
          {navigationRoutes.map(route => (
            <DrawerListItem
              key={ route.path }
              icon={ route.icon }
              text={ t(route.translationKey) }
              to={ route.path }
              open={ drawerOpen }
              badgeProps={ {
                badgeContent: Number(badgeInfo[route.badgeInfoKey]) || null,
                color: route.badgeColor,
                className: classes[route.badgeClassName]
              } }
            />
          ))}
        </List>
      </StyledDrawer>
    </>
  );
};

export default NavigationDrawer;